/**
 * Created by katarinababic on 27.6.24.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import { Media, createMedia } from '../Media/Media';

export type WebinarFaqEntry = {
  id: string;
  question: LocalizedValue[];
  answer: LocalizedValue[];
  askedAt: Date;
  responderName?: string;
  responderImage?: Media;
};

export function createWebinarFaqEntry(json?: Partial<WebinarFaqEntry>): WebinarFaqEntry {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    question: (json?.question ?? []).map((q: any) => createLocalizedValue(q)),
    answer: (json?.answer ?? []).map((a: any) => createLocalizedValue(a)),
    askedAt: json?.askedAt ? new Date(json.askedAt as any) : new Date(),
    responderName: json?.responderName,
    responderImage: json?.responderImage ? createMedia(json.responderImage as any) : undefined,
  });
}
